export enum XIDR_ACCOUNT_ACTIONS {
  SET_ACCOUNT_DETAIL_LIST = 'XIDR_ACCOUNT_ACTIONS.SET_ACCOUNT_DETAIL_LIST',
  SET_ACCOUNT_LIST = 'XIDR_ACCOUNT_ACTIONS.SET_ACCOUNT_LIST',
}
